<template>
  <div class="fieldset__wrap">
    <input
      :name="name"
      :type="(isRevealed ? 'text' : 'password')"
      :placeholder="placeholder"
      :pattern="pattern"
      :required="isRequired"
      class="input"
      :class="[ isMini && 'input--mini']"
      :maxlength="maxlength"
      :value="value"
      @keypress="$event.target.classList.add('touched')"
      @keyup.enter="$emit('keyup', $event.target.value)"
      @input="$emit('input', $event.target.value)"
      @focus="$emit('focus')"
    >
    <v-button
      class="fieldset__revealer"
      tabindex="-1"
      size="sm"
      color="transparent"
      @click="toggleVisibility"
    >
      <v-icon :type="(isRevealed ? 'hideview' : 'show')" />
      {{ isRevealed ? 'Hide' : 'Show' }}
    </v-button>
  </div>
</template>

<script>
  import Button from "@/atoms/Button";
  import Icon from "@/atoms/Icon";

  export default {
    components: {
      "v-button": Button,
      "v-icon": Icon,
    },
    props: {
      name: {
        type: String,
        default: null
      },
      pattern: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      maxlength: {
        type: Number,
        default: null
      },
      isRequired: {
        type: Boolean,
        default: false
      },
      isMini: {
        type: Boolean,
        default: false
      },
      value: {
        type: [String,Number],
        default: null
      }
    },
    data() {
      return {
        isRevealed: false
      };
    },
    methods: {
      toggleVisibility() {
        this.isRevealed = !this.isRevealed;
      }
    }
  };
</script>

<style lang="scss">
  .fieldset {
    &__wrap {
      position: relative;
    }
    &__revealer {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0.3125rem;
      min-width: 0;
    }
  }
</style>
